const map = {
	"./1.png": "./src/assets/images/product/1.png",
	"./10.png": "./src/assets/images/product/10.png",
	"./11.png": "./src/assets/images/product/11.png",
	"./12.png": "./src/assets/images/product/12.png",
	"./13.png": "./src/assets/images/product/13.png",
	"./14.png": "./src/assets/images/product/14.png",
	"./15.png": "./src/assets/images/product/15.png",
	"./2.png": "./src/assets/images/product/2.png",
	"./3.png": "./src/assets/images/product/3.png",
	"./4.png": "./src/assets/images/product/4.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/product sync recursive ^\\.\\/.*$";